import React, { useEffect, useState } from 'react';

const REVIEW_CATEGORIES = [
  ['WRONG_FACT', 'Wrong fact'],
  ['WRONG_BLOCKER', 'Wrong blocker'],
  ['MISSING_INFORMATION', 'Missing information'],
  ['MISLEADING_EXPLANATION', 'Misleading explanation'],
  ['OTHER', 'Other']
];

export function PilotFeedback({ response, onSubmit }) {
  const correlationId = response?._response?.correlationId ?? null;
  const [mode, setMode] = useState(null);
  const [saved, setSaved] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setMode(null);
    setSaved(null);
    setBusy(false);
    setError(null);
  }, [correlationId]);

  if (!correlationId || !onSubmit) return null;

  async function save(rating, category = null) {
    if (busy) return;
    setBusy(true);
    setError(null);

    try {
      await onSubmit(correlationId, rating, category);
      setSaved({ rating, category });
      setMode(null);
    } catch (err) {
      setError(
        err?.correlationId
          ? `${err.message} Correlation: ${err.correlationId}`
          : err.message
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="pilot-feedback" aria-label="Pilot feedback">
      <div className="pilot-feedback__top">
        <span>{saved ? 'Feedback saved' : 'Pilot feedback'}</span>
        <div className="pilot-feedback__actions">
          <button
            type="button"
            className={saved?.rating === 'HELPFUL' ? 'active' : ''}
            disabled={busy}
            onClick={() => save('HELPFUL')}
          >
            👍 Helpful
          </button>
          <button
            type="button"
            className={saved?.rating === 'NEEDS_REVIEW' ? 'active' : ''}
            disabled={busy}
            onClick={() => setMode(mode === 'review' ? null : 'review')}
          >
            👎 Needs review
          </button>
        </div>
      </div>

      {mode === 'review' ? (
        <div className="pilot-feedback__categories">
          <span>What needs review?</span>
          <div>
            {REVIEW_CATEGORIES.map(([code, label]) => (
              <button
                key={code}
                type="button"
                disabled={busy}
                onClick={() => save('NEEDS_REVIEW', code)}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      ) : null}

      {error ? <div className="pilot-feedback__error">{error}</div> : null}
    </div>
  );
}
